import { useEffect, useRef, useState, useLayoutEffect } from "react";
import MediaQuery from "react-responsive";
import style from "./MeterReading.module.scss";
import Heading from "../Typography/Heading/Heading";
import Text from "../Typography/Text/Text";
import Button from "../Button/Button";
import Input from "../Input/Input";
import submitReadings from "../../API/submitReadings";
import getBalance from "../../API/getBalance";
import close from "../../Static/images/close.svg";
import mobClose from "../../Static/images/mobClose.svg";
import sbp from "../../Static/images/sbp.png";
import accordionUp from "../../Static/images/accordionUp.svg";
import { isInfomat } from "../../API/URLS";
import Store from "../../Stores/Store";
import getQrForPayment from "../../API/getQrCodeForPayment";
import { inputFocusMessage } from "../../Utils/iframeMessenger";
import { canPay } from "../../Utils/Utils";
import {
  applyMoneyInputValue,
  focusMoneyInputSelection,
  formatMoneyOnBlur,
  formatMoneyValue,
  handleMoneyInputBeforeInput,
  handleMoneyInputKeyDown,
  parseMoneyAmount,
} from "../../Utils/moneyInput";

export default function MeterReading({
  meterDevice,
  setCurrentInput,
  setInitMR,
  initMR,
  idx,
}) {
  const [error, setError] = useState([]);
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const [payLoading, setPayLoading] = useState(false);
  const [inputs, setInputs] = useState([]);
  const [inputChange, setInputChange] = useState(false);
  const [readingsAbove, setReadingsAbove] = useState(false);
  const [accordionActive, setAccordionActive] = useState(false);
  //const [modalWantToPayActive, setModalWantToPayActive] = useState(false);
  const [sumCheckboxActive, setSumCheckboxActive] = useState(false);
  const [sumInputValue, setSumInputValue] = useState("");
  const [paymentActive, setPaymentActive] = useState(false);
  const [sumForPayment, setSumForPayment] = useState(0);
  const [mailCheckboxActive, setMailCheckboxActive] = useState(false);
  const [mailInputValue, setMailInputValue] = useState("");
  const [restBalanceInput, setRestBalanceInput] = useState("");
  const [modalQrPayActive, setModalQrPayActive] = useState(false);
  const [qrImage, setQrImage] = useState();
  //const [qrLink, setQrLink] = useState("");
  const [emailCheckboxActive, setEmailCheckboxActive] = useState(false);

  const inputsRef = useRef([]);
  const sumInputRef = useRef(null);

  useEffect(() => {
    const tempInputs = [];
    inputsRef.current.forEach((input) => {
      if (!inputs.includes(input.firstChild)) {
        tempInputs.push(input.firstChild);
      }
    });
    setInputs([...tempInputs]);

    function HARDCODEtypeOfService() {
      if (
        Store.payment.accounts.accounts[0].id_org === 1 ||
        Store.payment.accounts.accounts[0].id_org === "1"
      ) {
        Store.payment.setService("Электроснабжение");
      } else if (
        Store.payment.accounts.accounts[0].id_org === 2 ||
        Store.payment.accounts.accounts[0].id_org === "2"
      ) {
        Store.payment.setService("Водоснабжение, водоотведение");
      }
    }
    HARDCODEtypeOfService();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (idx === 0) {
      setAccordionActive(true);
    }
  }, [idx]);

  useEffect(() => {
    if (!sumCheckboxActive) return;

    const input = sumInputRef.current;
    if (!input) return;

    const initialSum = "0,00";
    input.value = initialSum;
    input.dataset.moneyLastValue = initialSum;
    input.focus({ preventScroll: true });
    focusMoneyInputSelection(input);
    inputFocusMessage("openNumKeyboard");
  }, [sumCheckboxActive]);

  // let tariffNames;
  const md = meterDevice;
  const indications = meterDevice.rates;

  let unit;
  //костыль
  if (indications[0].title_unit) {
    unit = indications[0].title_unit;
  } else {
    unit = "м³";
  }

  // if (indications.length === 1) {
  //   tariffNames = ["Сутки"];
  // } else if (indications.length === 2) {
  //   tariffNames = ["День", "Ночь"];
  // } else if (indications.length === 3) {
  //   tariffNames = ["Пик", "Полупик", "Ночь"];
  // }

  const errors = {
    verification:
      "Ваш прибор учета неисправен. Обратитесь в обслуживающее подразделение поставщика услуг",
    readingsLessInput: "Заполните все поля ввода данных",
    readingsLessBtn:
      "Не все поля заполнены, либо введенные показания меньше предыдущих",
  };

  function isVerificationPeriod() {
    if (!md.date_check) {
      return false;
    }
    const nowDate = new Date().toLocaleDateString("ru-RU", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });
    const currentDate = nowDate.split(".").reverse().join("");
    const mdDateCheck = new Date(md.date_check_next)
      .toLocaleDateString("ru-RU")
      .split(".")
      .reverse()
      .join("");

    if (currentDate >= mdDateCheck) {
      return true;
    }
    return false;
  }

  function setDifference(e) {
    let dif = 0;

    if (e.target.value) {
      const parsedInputValue = parseInt(e.target.value);
      if (!isNaN(parsedInputValue)) {
        e.target.value = parsedInputValue;
      } else {
        e.target.value = "";
      }
    }
    dif = e.target.value - Math.round(e.target.dataset.reading);
    if (isNaN(e.target.value)) {
      e.target.dataset.difference = "Введите данные в числовом формате";
    } else {
      e.target.dataset.difference = dif;
    }
    if (dif < 0) {
      e.target.dataset.difference = "Ваши показания меньше предыдущих";
    }
    setInputChange(!inputChange);
  }

  async function sendMeterReadings(forcibly) {
    const rates = [];

    setError(...[]);
    const tempErrors = [];
    inputsRef.current.forEach((input, idx) => {
      rates.push({
        id_tariff: indications[idx].id_tariff,
        id_indication: indications[idx].id_indication,
        reading: parseInt(input.firstChild.value),
      });
      if (
        parseInt(input.firstChild.value) <
        parseInt(input.firstChild.dataset.reading)
      ) {
        input.firstChild.dataset.error = true;
        tempErrors.push({ id: idx });
      } else if (!input.firstChild.value) {
        input.firstChild.dataset.error = true;
        tempErrors.push({ id: idx });
      } else {
        input.firstChild.dataset.error = false;
      }
    });
    setError([...tempErrors]);

    if (!forcibly) {
      let countNomrlaInputs = 0;
      if (!tempErrors.length) {
        inputsRef.current.forEach((input) => {
          if (input.dataset.difference > 5000) {
            setReadingsAbove(true);
          } else {
            countNomrlaInputs++;
            if (countNomrlaInputs === inputsRef.current.length) {
              submit();
            }
          }
        });
      }
    } else {
      setReadingsAbove(false);
      submit();
    }

    async function submit() {
      setSuccess(true);
      if (!success) {
        setLoading(true);
        const response = await submitReadings(md.id_meter, rates);
        setLoading(!response);
        setSuccess(response);
        setInitMR(idx + 1);
        inputsRef.current.forEach((input) => {
          input.firstChild.dataset.disabled = true;
          input.firstChild.dataset.success = true;
        });
        // calculatePaymentAmount(rates);
      }
    }
  }

  function modalClose() {
    setReadingsAbove(false);
  }

  async function submitForm(e) {
    e.preventDefault();
    await sendMeterReadings();
  }

  function clickToggleSum() {
    if (!sumCheckboxActive) {
      setSumInputValue("0,00");
      setRestBalanceInput(formatMoneyValue(sumForPayment / 100));
    } else {
      setSumInputValue("");
      setRestBalanceInput("");
    }
    setSumCheckboxActive(!sumCheckboxActive);
  }

  function clickToggleMail() {
    setMailCheckboxActive(!mailCheckboxActive);
  }

  function getManualAmountKopecks() {
    return Math.round(parseMoneyAmount(sumInputValue) * 100);
  }

  const isPayDisabled =
    sumCheckboxActive && getManualAmountKopecks() <= 0;

  function updateRestBalance(amountRub) {
    const paidKopecks = Math.round(parseMoneyAmount(amountRub) * 100);
    const restKopecks = sumForPayment - paidKopecks;
    if (restKopecks <= 0) {
      setRestBalanceInput(formatMoneyValue(0));
    } else {
      setRestBalanceInput(formatMoneyValue(restKopecks / 100));
    }
  }

  function sumInputChange() {
    const input = sumInputRef.current;
    const filteredValue = applyMoneyInputValue(input);
    if (!input || filteredValue === null) return;

    setSumInputValue(input.value);
    updateRestBalance(input.value);
  }

  function sumInputFocus(e) {
    inputFocusMessage("openNumKeyboard");
    focusMoneyInputSelection(e.target);
  }

  function sumInputBlur() {
    inputFocusMessage("closeKeyboard");

    const input = sumInputRef.current;
    if (!input) return;

    const formatted = formatMoneyOnBlur(input.value);
    input.value = formatted;
    input.dataset.moneyLastValue = formatted;
    setSumInputValue(formatted);
    updateRestBalance(formatted);
  }

  async function calculatePaymentAmount(rates) {
    let balance = await calculateBalance();
    if (balance !== "error") {
      let sum =
        balance +
        indications.reduce(
          (accumulator, item, idx) =>
            accumulator + item.cost * (rates[idx].reading - item.reading),
          0,
        );
      if (sum <= 0) {
        /////установить amount в terminalPaymentInfo
        setSumForPayment(0);
      } else {
        /////установить amount в terminalPaymentInfo
        // Сумма для оплаты в копейках, округленная в большую сторону (3.544 р. -> 355 коп.)
        setSumForPayment(Math.ceil(parseFloat(sum).toFixed(3) * 100));
      }
      // setPaymentActive(true);
    }
    checkDefaultEmail();
  }

  async function calculateBalance() {
    let balance = await getBalance(Store.payment.accounts.accounts[0].id_PA);
    if (isInfomat) {
      Store.payment.setTerminalPaymentInfo(balance);
    }
    if (balance !== "error") {
      balance = balance.accounts[0].services.reduce(
        (accumulator, service) => accumulator + Number(service.amount),
        0,
      );
      balance = Number(balance.toFixed(2));
    }
    return balance;
  }

  function getGateAccountMeta(account) {
    const ls = String(
      account.number ||
        Store.payment.accountInfo?.number ||
        Store.payment.accounts?.number ||
        Store.payment.accounts?.accounts?.[0]?.number ||
        "",
    );
    const serviceName =
      account.service_name ||
      Store.payment.service ||
      Store.payment.accounts?.accounts?.[0]?.service_name ||
      "";

    return { ls, serviceName };
  }

  function setCorrectPaymentInfo() {
    let tempData = JSON.parse(
      JSON.stringify(Store.payment.terminalPaymentInfo),
    );
    //Создаем json для эндпоинта эквайринга /create. Создается на основе /saldo_info (так исторически сложилось)
    tempData.type = "payment";
    tempData.is_infomat = true;
    tempData.payment_method_id = 8;
    delete tempData.totalNegativeBalance;
    delete tempData.totalPositiveBalance;
    tempData.unified_id = null;
    tempData.unified_number = null;
    tempData.code = Store.payment.accountInfo.number;
    tempData.email = "";

    const useManual = sumCheckboxActive;
    const baseKopecks = useManual ? getManualAmountKopecks() : sumForPayment;

    const gateInfo = tempData.accounts.map((account) => {
      const { ls, serviceName } = getGateAccountMeta(account);

      if (useManual && account.tax_percent > 0) {
        const tax_amount = Math.round(baseKopecks * account.tax_percent);
        return {
          ls,
          positions: [
            {
              name: serviceName,
              amount: baseKopecks,
              tax_amount,
            },
          ],
        };
      }
      return {
        ls,
        positions: [
          {
            name: serviceName,
            amount: baseKopecks,
            tax_amount: 0,
          },
        ],
      };
    });

    let totalAmount = 0;
    tempData.accounts.forEach((account) => {
      delete account.totalAccountNegativeBalance;
      delete account.totalAccountPositiveBalance;

      if (useManual && account.tax_percent > 0) {
        account.amount = baseKopecks;
        account.tax_amount = Math.round(account.amount * account.tax_percent);
        account.amount = account.amount + account.tax_amount;
      } else {
        account.amount = baseKopecks;
        account.tax_amount = 0;
      }
      totalAmount += account.amount;

      delete account.number;
      delete account.id_org;
      delete account.service_name;
      delete account.services;
      delete account.tax_percent;
    });

    tempData.amount = totalAmount;
    tempData.gate = {
      amount: totalAmount,
      cost: totalAmount,
      info: gateInfo,
    };
    Store.payment.setTerminalPaymentInfo(tempData);
  }

  function checkDefaultEmail() {
    if (!isInfomat) {
      let defaultEmail = "";
      Store.payment.accounts.accounts.forEach((account) => {
        if (account.email && Number(account.id_org) === 1) {
          defaultEmail = account.email;
        }
      });
      if (!defaultEmail) {
        Store.payment.accounts.accounts.forEach((account) => {
          if (account.email) {
            defaultEmail = account.email;
          }
        });
      }
      if (defaultEmail) {
        clickToggleMail();
        setEmailCheckboxActive(true);
        setMailInputValue(defaultEmail);
      }
    }
  }

  async function payment() {
    const amountKopecks = sumCheckboxActive
      ? getManualAmountKopecks()
      : sumForPayment;

    if (!amountKopecks || amountKopecks <= 0) return;

    if (isInfomat) {
      const balance = await getBalance(
        Store.payment.accounts.accounts[0].id_PA,
      );
      if (balance !== "error") {
        Store.payment.setTerminalPaymentInfo(balance);
      }
      setCorrectPaymentInfo();
      Store.payment.setAmount(Store.payment.terminalPaymentInfo.amount);
      Store.payment.setPaymentWindowActive(true);
    } else if (!isInfomat) {
      if (mailCheckboxActive) {
        Store.payment.setEmail(mailInputValue);
      } else {
        Store.payment.setEmail("");
      }
      setPayLoading(true);
      Store.payment.setAmount(amountKopecks);
      const data = await getQrForPayment(
        Store.payment.amount,
        Store.payment.accounts.accounts[0].id_PA,
        Store.payment.email,
        Store.payment.service,
      );
      if (data) {
        setQrImage(data.data.data.image.content);
        setModalQrPayActive(true);
      }
      setPayLoading(false);
    }
  }

  //function clickQrCode() {
  //  const link = document.createElement("a");
  //  link.href = qrLink;
  //  link.setAttribute("target", "_blank");
  //  document.body.appendChild(link);
  //  link.click();
  //  link.parentNode.removeChild(link);
  //}
  // ====== Анимация высоты без "auto" + защита от скачков ======
  const bodyRef = useRef(null);
  const isFirstMount = useRef(true);

  const [bodyHeight, setBodyHeight] = useState(null); // null => "auto"
  const [animEnabled, setAnimEnabled] = useState(false);

  // 0) Первый маунт: сразу раскрыто (auto), анимацию включаем со следующего кадра
  useLayoutEffect(() => {
    const el = bodyRef.current;
    if (!el) return;

    // Старт: раскрыто
    setAnimEnabled(false);
    setBodyHeight(null); // auto

    requestAnimationFrame(() => {
      isFirstMount.current = false;
      setAnimEnabled(true);
    });
  }, []);

  // 1) ResizeObserver: когда раскрыто (success=false), поддерживаем корректную высоту
  useLayoutEffect(() => {
    const el = bodyRef.current;
    if (!el) return;

    const ro = new ResizeObserver(() => {
      // Пока не успех — блок раскрыт, держим высоту = auto (или можно держать px)
      if (!success) {
        setBodyHeight(null); // auto, чтобы не было обрезаний
      }
    });

    ro.observe(el);
    return () => ro.disconnect();
  }, [success]);

  // 2) Схлопываем ТОЛЬКО при success=true
  useLayoutEffect(() => {
    const el = bodyRef.current;
    if (!el) return;

    if (isFirstMount.current) return; // на первом рендере не трогаем

    if (success) {
      // auto -> px -> 0 (чтобы height мог анимироваться)
      const h = el.scrollHeight;
      setBodyHeight(h);
      requestAnimationFrame(() => setBodyHeight(0));
    } else {
      // возвращаем в раскрытое состояние без анимационных "прыжков"
      setBodyHeight(null); // auto
    }
  }, [success, indications.length]);
  return (
    <>
      <MediaQuery minWidth={769}>
        <div
          className={
            isInfomat ? `${style.wrap} ${style.infomat}` : `${style.wrap}`
          }
        >
          <form onSubmit={(e) => submitForm(e)}>
            <div className={style.wrap__title}>
              <div className={style.meterDevice}>
                <Heading level="h4">
                  ПУ: {md.device_title} - {md.modification} (№{md.serial_number}
                  )
                </Heading>
              </div>
              {md.type_locality && (
                <div className={style.mdAddress}>
                  <Text size="small">
                    {md.type_locality} {md.locality} {md.type_street}{" "}
                    {md.street} {md.type_house} {md.house} {md.type_building}{" "}
                    {md.building} {md.condos_number && "кв."} {md.condos_number}
                  </Text>
                </div>
              )}
              {md.date_check && (
                <div
                  className={
                    isVerificationPeriod() &&
                    Number(Store.payment.accounts.accounts[0].id_org) === 2
                      ? `${style.verificationDate} ${style.mdError}`
                      : `${style.verificationDate}`
                  }
                >
                  <Text size="small">
                    {isVerificationPeriod() &&
                    Number(Store.payment.accounts.accounts[0].id_org) === 2
                      ? `Срок поверки истек: ${new Date(
                          md.date_check_next,
                        ).toLocaleDateString("ru-RU")}`
                      : `Дата очередной поверки: ${new Date(
                          md.date_check_next,
                        ).toLocaleDateString("ru-RU")}`}
                  </Text>
                </div>
              )}

              <div className={style.placement}>
                {md.placement && (
                  <Text size="small">Место установки: {md.placement}</Text>
                )}
              </div>
            </div>
            <div
              ref={bodyRef}
              className={style.wrap__body}
              style={{
                height: bodyHeight === null ? "auto" : `${bodyHeight}px`,
                overflow: bodyHeight === null ? "visible" : "hidden",
                opacity: success ? 0 : 1,
                pointerEvents: success ? "none" : "auto",
                transition: animEnabled
                  ? "height 300ms ease, opacity 200ms ease"
                  : "none",
              }}
            >
              {indications.map((el, idx) => (
                <div key={idx} className={style.meterReading}>
                  <div className={style.title}>
                    <Text size="medium" fw={500}>
                      {el.title}
                    </Text>
                  </div>
                  <div className={style.info}>
                    <div className={style.info__item}>
                      <Text size="meterReadingInfo">
                        Предыдущее показание:{" "}
                        <span>
                          {Math.round(el.reading)} {unit}
                        </span>
                      </Text>
                    </div>
                    <div className={style.info__item}>
                      <Text size="meterReadingInfo">
                        От:{" "}
                        <span>
                          {new Date(el.date_reading).toLocaleDateString(
                            "ru-RU",
                          )}
                        </span>
                      </Text>
                    </div>
                    {el.cost !== 0 ? (
                      <div className={style.info__item}>
                        <Text size="meterReadingInfo">
                          Тариф: <span>{el.cost}</span>
                        </Text>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                  <div
                    data-difference={inputs[idx]?.dataset.difference}
                    className={style.input}
                    ref={(el) => {
                      if (el && !inputsRef.current.includes(el)) {
                        inputsRef.current.push(el);
                      }
                    }}
                  >
                    <Input
                      clickHandler={setCurrentInput}
                      changeHandler={setDifference}
                      disabled={
                        isVerificationPeriod() &&
                        Number(Store.payment.accounts.accounts[0].id_org) === 2
                      }
                      autofocus={idx === 0 && initMR}
                      reading={el.reading}
                      placeholder={
                        el.current_month_reading_value &&
                        el.current_month_reading_date
                          ? `Учтено: ${
                              el.current_month_reading_value
                            } ${unit} от ${new Date(
                              el.current_month_reading_date,
                            ).toLocaleDateString("ru-RU")}`
                          : ""
                      }
                      keyboardTypeNumber={true}
                      maxLength={8}
                    />
                    {!(
                      isVerificationPeriod() &&
                      Number(Store.payment.accounts.accounts[0].id_org) === 2
                    ) ? (
                      <div className={style.difference}>
                        {inputs[idx]?.dataset.difference >= 0 ? (
                          <Text size="meterReadingInfo">
                            Разница: {inputs[idx]?.dataset.difference} {unit}
                          </Text>
                        ) : (
                          <Text size="meterReadingInfo">
                            {inputs[idx]?.dataset.difference}
                          </Text>
                        )}
                      </div>
                    ) : (
                      <></>
                    )}
                  </div>
                </div>
              ))}
            </div>
            <div className={style.button}>
              <Button
                disabled={
                  isVerificationPeriod() &&
                  Number(Store.payment.accounts.accounts[0].id_org) === 2
                }
                success={success}
                loading={loading}
              >
                Отправить показания
                {/* {isVerificationPeriod() ? `Ошибка` : `Отправить показания`}  */}
              </Button>
            </div>
          </form>
          {isVerificationPeriod() &&
            Number(Store.payment.accounts.accounts[0].id_org) === 2 && (
              <div className={style.error}>
                <Text size="small">{errors.verification}</Text>
              </div>
            )}
          {error.length > 0 && (
            <div className={style.error}>
              <Text size="small">{errors.readingsLessBtn}</Text>
            </div>
          )}
          {/* {paymentActive && canPay() && (
            <div className={style.payment}>
              <div className={style.total}>
                <div className={style.firstRow}>
                  <div className={style.firstRow__text}>
                    <Text size="medium">Итого к оплате:</Text>
                  </div>
                  <div className={style.firstRow__value}>
                    {sumForPayment / 100} ₽
                  </div>
                </div>
                <div className={style.secondRow}>
                  *Сумма платежа является предварительной
                </div>
              </div>
              <div className={style.toggleWrap}>
                <Text size="medium">Указать сумму вручную</Text>
                <div className={style.checkbox}>
                  <input
                    type="checkbox"
                    className={style.toggle}
                    onClick={() => {
                      clickToggleSum();
                    }}
                    defaultChecked={false}
                  />
                </div>
              </div>
              {sumCheckboxActive && (
                <div className={style.sumInputs}>
                  <div className={style.enterValue}>
                    <div className={style.enterValue__title}>
                      <Text size="medium">Введите сумму платежа</Text>
                    </div>
                    <label className={style.inputWrapper}>
                      <input
                        key="manual-sum-input"
                        ref={sumInputRef}
                        defaultValue="0,00"
                        onChange={sumInputChange}
                        onKeyDown={handleMoneyInputKeyDown}
                        onBeforeInput={handleMoneyInputBeforeInput}
                        onFocus={sumInputFocus}
                        onBlur={sumInputBlur}
                        className={style.sumInput}
                        maxLength={12}
                      />
                      <span className={style.rubSuffix} aria-hidden="true">
                        руб
                      </span>
                    </label>
                  </div>
                  <div className={style.enterValue}>
                    <div className={style.enterValue__title}>
                      <Text size="medium">Остаток</Text>
                    </div>
                    <label
                      className={`${style.inputWrapper} ${style.inputWrapperReadonly}`}
                    >
                      <input
                        value={restBalanceInput}
                        className={style.sumInput}
                        readOnly
                        tabIndex={-1}
                      />
                      <span className={style.rubSuffix} aria-hidden="true">
                        руб
                      </span>
                    </label>
                  </div>
                </div>
              )}
              <div
                className={`${style.email} ${!isInfomat && `${style.active}`}`}
              >
                <div className={style.toggleWrap}>
                  <Text size="medium">
                    Прислать квитанцию об оплате на E-mail
                  </Text>
                  <div className={style.checkbox}>
                    <input
                      type="checkbox"
                      className={style.toggle}
                      onClick={() => {
                        clickToggleMail();
                      }}
                      defaultChecked={emailCheckboxActive}
                    />
                  </div>
                </div>
                {mailCheckboxActive && (
                  <div className={style.enterValue}>
                    <div className={style.enterValue__title}>
                      <Text size="medium">E-mail</Text>
                    </div>
                    <input
                      onChange={(e) => setMailInputValue(e.target.value)}
                      value={mailInputValue}
                      className={style.enterValue__input}
                      autoFocus={true}
                      onFocus={() => inputFocusMessage("openKeyboard")}
                      onBlur={() => inputFocusMessage("closeKeyboard")}
                      placeholder="Введите E-mail"
                    />
                  </div>
                )}
              </div>
              <div className={style.buttonPay}>
                <Button
                  disabled={isPayDisabled}
                  loading={payLoading}
                  clickHandler={payment}
                >
                  Оплатить
                </Button>
              </div>
            </div>
          )} */}
        </div>
      </MediaQuery>
      <MediaQuery maxWidth={768}>
        <div className={style.wrap}>
          <form onSubmit={(e) => submitForm(e)}>
            <div
              className={style.wrap__title}
              onClick={() => setAccordionActive(!accordionActive)}
            >
              <div className={style.meterDevice}>
                <Text size="medium" fw={500}>
                  ПУ: {md.device_title} - {md.modification} (№{md.serial_number}
                  )
                </Text>
              </div>
              {md.type_locality && (
                <div className={style.mdAddress}>
                  <Text size="small">
                    {md.type_locality} {md.locality} {md.type_street}{" "}
                    {md.street} {md.type_house} {md.house} {md.type_building}
                    {md.building} {md.condos_number && "кв."} {md.condos_number}
                  </Text>
                </div>
              )}
              {md.date_check && (
                <div
                  className={
                    isVerificationPeriod() &&
                    Number(Store.payment.accounts.accounts[0].id_org) === 2
                      ? `${style.verificationDate} ${style.mdError}`
                      : `${style.verificationDate}`
                  }
                >
                  <Text size="small">
                    {isVerificationPeriod() &&
                    Number(Store.payment.accounts.accounts[0].id_org) === 2
                      ? `Срок поверки истек: ${new Date(
                          md.date_check_next,
                        ).toLocaleDateString("ru-RU")}`
                      : `Дата очередной поверки: ${new Date(
                          md.date_check_next,
                        ).toLocaleDateString("ru-RU")}`}
                  </Text>
                </div>
              )}

              <div className={style.placement}>
                {md.placement && (
                  <Text size="small">Место установки: {md.placement}</Text>
                )}
              </div>

              <div
                className={
                  accordionActive
                    ? `${style.accordionIcon} ${style.accordionVisible}`
                    : `${style.accordionIcon} ${style.accordionHidden}`
                }
              >
                <img src={accordionUp} alt="" />
              </div>
            </div>
            <div
              className={
                accordionActive
                  ? `${style.wrap__body} `
                  : `${style.wrap__body} ${style.accordionHidden}`
              }
            >
              <div
                ref={bodyRef}
                style={{
                  height: bodyHeight === null ? "auto" : `${bodyHeight}px`,
                  overflow: bodyHeight === null ? "visible" : "hidden",
                  opacity: success ? 0 : 1,
                  pointerEvents: success ? "none" : "auto",
                  transition: animEnabled
                    ? "height 300ms ease, opacity 200ms ease"
                    : "none",
                }}
              >
                {indications.map((el, idx) => (
                  <div key={idx} className={style.meterReading}>
                    <div className={style.title}>
                      <Text size="medium">{el.title}</Text>
                    </div>
                    <div className={style.info}>
                      <div className={style.info__item}>
                        <Text size="meterReadingInfo">
                          Предыдущее показание:{" "}
                          <span>
                            {Math.round(el.reading)} {unit}
                          </span>
                        </Text>
                      </div>
                      <div className={style.info__item}>
                        <Text size="meterReadingInfo">
                          От:{" "}
                          <span>
                            {new Date(el.date_reading).toLocaleDateString(
                              "ru-RU",
                            )}
                          </span>
                        </Text>
                      </div>
                      {el.cost !== 0 ? (
                        <div className={style.info__item}>
                          <Text size="meterReadingInfo">
                            Тариф: <span>{el.cost}</span>
                          </Text>
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                    <div
                      data-difference={inputs[idx]?.dataset.difference}
                      className={style.input}
                      ref={(el) => {
                        if (el && !inputsRef.current.includes(el)) {
                          inputsRef.current.push(el);
                        }
                      }}
                    >
                      <Input
                        clickHandler={setCurrentInput}
                        changeHandler={setDifference}
                        disabled={
                          isVerificationPeriod() &&
                          Number(Store.payment.accounts.accounts[0].id_org) ===
                            2
                        }
                        autofocus={idx === 0 && initMR}
                        reading={el.reading}
                        placeholder={
                          el.current_month_reading_value &&
                          el.current_month_reading_date
                            ? `Учтено: ${
                                el.current_month_reading_value
                              } ${unit} от ${new Date(
                                el.current_month_reading_date,
                              ).toLocaleDateString("ru-RU")}`
                            : ""
                        }
                        maxLength={8}
                      />
                      {!(
                        isVerificationPeriod() &&
                        Number(Store.payment.accounts.accounts[0].id_org) === 2
                      ) ? (
                        <div className={style.difference}>
                          {inputs[idx]?.dataset.difference >= 0 ? (
                            <Text size="meterReadingInfo">
                              Разница: {inputs[idx]?.dataset.difference} {unit}
                            </Text>
                          ) : (
                            <Text size="meterReadingInfo">
                              {inputs[idx]?.dataset.difference}
                            </Text>
                          )}
                        </div>
                      ) : (
                        <></>
                      )}
                    </div>
                  </div>
                ))}
              </div>
              <div className={`${style.button}`}>
                <Button
                  disabled={
                    isVerificationPeriod() &&
                    Number(Store.payment.accounts.accounts[0].id_org) === 2
                  }
                  success={success}
                  loading={loading}
                >
                  Отправить показания
                </Button>
              </div>
              {isVerificationPeriod() &&
                Number(Store.payment.accounts.accounts[0].id_org) === 2 && (
                  <div className={`${style.error}`}>
                    <Text size="small">{errors.verification}</Text>
                  </div>
                )}
              {error.length > 0 && (
                <div className={style.error}>
                  <Text size="small">{errors.readingsLessBtn}</Text>
                </div>
              )}
              {/*{paymentActive && (
                <div className={style.payment}>
                  <div className={style.total}>
                    <div className={style.total__text}>
                      <Text size="medium">Итого к оплате:</Text>
                    </div>
                    <div className={style.total__value}>
                      {sumForPayment / 100} ₽
                    </div>
                  </div>
                  <div className={style.toggleWrap}>
                    <Text size="medium">Указать сумму вручную</Text>
                    <div className={style.checkbox}>
                      <input
                        type="checkbox"
                        className={style.toggle}
                        onClick={() => {
                          clickToggleSum();
                        }}
                        defaultChecked={false}
                      />
                    </div>
                  </div>
                  {sumCheckboxActive && (
                    <div className={style.sumInputs}>
                      <div className={style.enterValue}>
                        <div className={style.enterValue__title}>
                          <Text size="medium">Введите сумму платежа</Text>
                        </div>
                        <label className={style.inputWrapper}>
                          <input
                            ref={sumInputRef}
                            defaultValue={sumInputValue}
                            onChange={sumInputChange}
                            onKeyDown={handleMoneyInputKeyDown}
                            onBeforeInput={handleMoneyInputBeforeInput}
                            onFocus={sumInputFocus}
                            onBlur={sumInputBlur}
                            className={style.sumInput}
                            autoFocus={true}
                            maxLength={12}
                          />
                          <span className={style.rubSuffix} aria-hidden="true">
                            руб
                          </span>
                        </label>
                      </div>
                      <div className={style.enterValue}>
                        <div className={style.enterValue__title}>
                          <Text size="medium">Остаток</Text>
                        </div>
                        <label
                          className={`${style.inputWrapper} ${style.inputWrapperReadonly}`}
                        >
                          <input
                            value={restBalanceInput}
                            className={style.sumInput}
                            readOnly
                            tabIndex={-1}
                          />
                          <span className={style.rubSuffix} aria-hidden="true">
                            руб
                          </span>
                        </label>
                      </div>
                    </div>
                  )}
                  {!isInfomat && (
                    <>
                      <div className={style.toggleWrap}>
                        <Text size="medium">
                          Прислать квитанцию об оплате на E-mail
                        </Text>
                        <div className={style.checkbox}>
                          <input
                            type="checkbox"
                            className={style.toggle}
                            onClick={() => {
                              clickToggleMail();
                            }}
                            defaultChecked={false}
                          />
                        </div>
                      </div>
                      {mailCheckboxActive && (
                        <div className={style.enterValue}>
                          <div className={style.enterValue__title}>
                            <Text size="medium">E-mail</Text>
                          </div>
                          <input
                            onChange={(e) => setMailInputValue(e.target.value)}
                            value={mailInputValue}
                            className={style.enterValue__input}
                            autoFocus={true}
                            onFocus={() => inputFocusMessage("openKeyboard")}
                            onBlur={() => inputFocusMessage("closeKeyboard")}
                            placeholder="Введите E-mail"
                          />
                        </div>
                      )}
                    </>
                  )}
                  <div className={style.buttonPay}>
                    <Button loading={payLoading} clickHandler={payment}>
                      Оплатить
                    </Button>
                  </div>
                </div>
              )}*/}
            </div>
          </form>
        </div>
      </MediaQuery>
      {readingsAbove && (
        <div
          className={
            isInfomat
              ? `${style.readingsAbove} ${style.infomat}`
              : `${style.readingsAbove}`
          }
          onClick={() => modalClose()}
        >
          <div
            className={style.readingsAbove__wrap}
            //onClick={(e) => e.stopPropagation()}
          >
            <div
              className={style.readingsAbove__wrap__close}
              onClick={() => modalClose()}
            >
              <MediaQuery minWidth={769}>
                <img src={close} alt="" />
              </MediaQuery>
              <MediaQuery maxWidth={768}>
                <img src={mobClose} alt="" />
              </MediaQuery>
            </div>
            <div className={style.readingsAbove__wrap__content}>
              <div className={style.readingsAbove__wrap__content__title}>
                <Heading level="h1">
                  Ваши текущие показания <br />
                  превышают 5000 {unit}
                </Heading>
              </div>
              <div className={style.readingsAbove__wrap__content__btns}>
                <div
                  className={style.readingsAbove__wrap__content__btns__btn}
                  onClick={() => sendMeterReadings(true)}
                >
                  <Text size="btnText">
                    <MediaQuery minWidth={769}>Отправить показания</MediaQuery>
                    <MediaQuery maxWidth={768}>Отправить</MediaQuery>
                  </Text>
                </div>
                <div
                  className={`${style.readingsAbove__wrap__content__btns__btn} ${style.sec}`}
                  onClick={() => modalClose()}
                >
                  <Text size="btnText">Отменить</Text>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {/* {modalQrPayActive && (
        <div
          className={style.modalQrPay}
          onClick={() => setModalQrPayActive(false)}
        >
          <div
            className={style.modalQrPay__wrap}
            onClick={(e) => e.stopPropagation()}
          >
            <div
              className={style.modalQrPay__wrap__close}
              onClick={() => setModalQrPayActive(false)}
            >
              <img src={close} alt="" />
            </div>
            <div className={style.modalQrPay__wrap__content}>
              <div className={style.modalQrPay__wrap__content__title}>
                <Heading level="h1">Система быстрых платежей</Heading>
              </div>
              <div className={style.modalQrPay__wrap__content__subtitle}>
                Наведите камеру смартфона для перехода в мобильное <br />
                приложение вашего банка для завершения оплаты
              </div>
              <div className={style.modalQrPay__wrap__content__sum}>
                <Heading level="h5">
                  Сумма к оплате {Store.payment.amount / 100} ₽
                </Heading>
              </div>
              <div className={style.modalQrPay__wrap__content__pay}>
                <div
                  className={style.modalQrPay__wrap__content__pay__qr}
                  //onClick={() => clickQrCode()}
                >
                  {qrImage && (
                    <img src={`data:image/jpeg;base64,${qrImage}`} alt="" />
                  )}
                </div>
                <div className={style.modalQrPay__wrap__content__pay__sbp}>
                  <img src={sbp} alt="" />
                </div>
              </div>
              <div
                className={style.modalQrPay__wrap__content__btn}
                onClick={() => setModalQrPayActive(false)}
              >
                <Text size="btnText">Отменить</Text>
              </div>
            </div>
          </div>
        </div>
      )} */}
      {/*{modalWantToPayActive && (
        <div
          className={
            isInfomat
              ? `${style.modalWantToPay} ${style.infomat}`
              : `${style.modalWantToPay}`
          }
          onClick={() => setModalWantToPayActive(false)}
        >
          <div
            className={style.modalWantToPay__wrap}
            onClick={(e) => e.stopPropagation()}
          >
            <div
              className={style.modalWantToPay__wrap__close}
              onClick={() => setModalWantToPayActive(false)}
            >
              <MediaQuery minWidth={769}>
                <img src={close} alt="" />
              </MediaQuery>
              <MediaQuery maxWidth={768}>
                <img src={mobClose} alt="" />
              </MediaQuery>
            </div>
            <div className={style.modalWantToPay__wrap__content}>
              <div className={style.modalWantToPay__wrap__content__title}>
                <Heading level="h1">
                  {isInfomat
                    ? "Желаете оплатить показания?"
                    : "Желаете оплатить переданные показания?"}
                </Heading>
              </div>
              <div className={style.modalWantToPay__wrap__content__btns}>
                <div
                  className={style.modalWantToPay__wrap__content__btns__btn}
                  onClick={() => wantToPay()}
                >
                  <Text size="btnText">
                    {isInfomat ? "Да" : "Да, оплатить по QR коду"}
                  </Text>
                </div>
                <div
                  className={`${style.modalWantToPay__wrap__content__btns__btn} ${style.sec}`}
                  onClick={() => setModalWantToPayActive(false)}
                >
                  <Text size="btnText">Нет</Text>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}*/}
    </>
  );
}
